module.exports = __webpack_public_path__ + "img/usa-ischemic-heart-disease-male.74181ead.png";